import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/Menu'
import ContactContent from '../pages/contactContent'
import Toppart from '../pages/toppart'
import Footer from '../pages/Footer'

export default function Home() {
	return(		
		<div id="maincontainer">
			<Toppart />
			<MenuBar />
			<ContactContent />
			<Footer />			
		</div>	
	)
}
